export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";